// extracted by mini-css-extract-plugin
export default {"header":"Header_header__t+TLN","title":"Header_title__q3t3E","logo":"Header_logo__HCz6H","line":"Header_line__qNYJV"};